import { ApiUrls } from "./api-urls";
import { ApplicationService, HttpService } from "./application.service"

export const ProjectService = {
    save: (data: any) => {
        return ApplicationService.post<any>(ApiUrls.PROJECT_POST, data);
    },
    saveFinancialYear: (data: any) => {
        return ApplicationService.post<any>(ApiUrls.SAVE_FINANCIAL_YEAR, data);
    },
    getData: (propertyId: number) => {
        return ApplicationService.get<any>(ApiUrls.PROJECT_TOWER_GET(propertyId));
    },
    getProperties: () => {
        return ApplicationService.get<any>(ApiUrls.PROJECT_PROPERTIES);
    },
    floorData: (towerId: number) => {
        return ApplicationService.get<any>(ApiUrls.PROJECT_FLOOR_GET(towerId));
    },
    flatData: (floorId: number, unsoled?: boolean) => {
        return ApplicationService.get<any>(ApiUrls.PROJECT_FLAT_GET(floorId, unsoled));
    },
    getFlatData: (propertyTypeId: any) => {
        return ApplicationService.get<any>(propertyTypeId ? ApiUrls.PROJECT_FLOOR_FLAT_BY_TYPE(propertyTypeId)
            : ApiUrls.PROJECT_FLOOR_FLAT);
    },
    userprojects: () => {
        return ApplicationService.get<any>(ApiUrls.USER_PROJECTS);
    },
    changeproject: (projectId: number) => {
        return ApplicationService.get<any>(ApiUrls.CHANGE_PROJECT(projectId));
    },
    getFinancialYear: () => {
        return ApplicationService.get<any>(ApiUrls.FINANCIAL_YEAR);
    }
}




